module.exports = __webpack_public_path__ + "static/media/filters-icon.27c17c40.svg";